import { render, staticRenderFns } from "./GradeListing.vue?vue&type=template&id=21483fce&"
import script from "./GradeListing.vue?vue&type=script&lang=js&"
export * from "./GradeListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports